import templateUrl from "./edit-phone.html"

export const EditPhoneComponent = {
    templateUrl,
    controllerAs: "vm",
    bindings: {
        phone: "<",
        required: "<?",
        showExtension: "<?",
        disabled: "<?"
    }
}
